import * as React from 'react';

import TrashEmpty140 from './TrashEmpty140';

export const trashEmpty140 = () => <TrashEmpty140 />;

export default {
    title: 'Illustration|TrashEmpty140',
    component: TrashEmpty140,
    parameters: {
        notes: "`import TrashEmpty140 from 'box-ui-elements/es/illustration/TrashEmpty140';`",
    },
};
